import { useMe } from './me';

export const useTenantManagerPermission = (onlyEdit?: boolean) => {
  return useMe((data) => {
    const permission = data.role.resourceGroupPermissions.administrator;
    return permission === 'edit' || (!onlyEdit && permission === 'view');
  });
};

export const useMasterTablePermission = (onlyEdit?: boolean) => {
  return useMe((data) => {
    const permission = data.role.resourceGroupPermissions.masterTable;
    return permission === 'edit' || (!onlyEdit && permission === 'view');
  });
};

export const useProjectPermission = (onlyEdit?: boolean) => {
  return useMe((data) => {
    const permission = data.role.resourceGroupPermissions.project;
    return (
      permission === 'privilege' ||
      permission === 'edit' ||
      (!onlyEdit &&
        (permission === 'view' || permission === 'view-all-privilege'))
    );
  });
};

export const useIndicatorPermission = (onlyEdit?: boolean) => {
  return useMe((data) => {
    const permission = data.role.resourceGroupPermissions.indicator;
    return permission === 'edit' || (!onlyEdit && permission === 'view');
  });
};

export const useGlobalTagPermission = (onlyEdit?: boolean) => {
  return useMe((data) => {
    const permission = data.role.resourceGroupPermissions.globalTag;
    return permission === 'edit' || (!onlyEdit && permission === 'view');
  });
};

export const useLocalTagPermission = (onlyEdit?: boolean) => {
  return useMe((data) => {
    const permission = data.role.resourceGroupPermissions.localTag;
    return permission === 'edit' || (!onlyEdit && permission === 'view');
  });
};
